// extracted by mini-css-extract-plugin
module.exports = {"root":"MainImage-root-0fb6","left":"MainImage-left-0fb6","right":"MainImage-right-0fb6"};